<div class="pt-3 px-2 md:px-4 pb-8 safe-area-margin" aria-label="contacts-list-container">
  <div class="flex align-items-center justify-content-between" aria-label="contacts-list-header">
      <h1 data-cy="title" class="text-base md:text-lg flex align-items-center mb-0 line-height-1" data-cy="title" aria-label="contacts-list-title">
        {{'CONTACTS.CONTACTS' | translate}}
        <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="#" target="_blank" aria-label="help-guide-link" data-testid="help-guide-link">
          <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
          <span class="ml-2 hidden md:inline-block">{{'CONTACTS.HELP_GUIDE' | translate}}</span>
        </a>
      </h1>
      <!-- <div aria-label="add-contact-button-container">
        <p-button icon="fa fa-plus" styleClass="md:hidden" aria-label="add-contact-mobile"></p-button>
        <p-button icon="fa fa-plus" label="Add New Contact" styleClass="text-sm hidden md:inline-flex" aria-label="add-contact-desktop"></p-button>
      </div> -->
  </div>

  <div class="shadow-2 surface-0 border-round mt-3" aria-label="contacts-list-content">
    <div class="card relative mt-2 border-bottom-1 border-300 md:mt-0 px-3 md:px-2 pt-3 md:pt-2" aria-label="contacts-list-card">
      <div class="flex flex-wrap align-items-center justify-content-between mb-2" aria-label="contacts-list-actions">
        <div class="mr-2 mb-2 md:mb-0" aria-label="total-contacts">
          <span class="text-900 text-sm">{{'CONTACTS.TOTAL_CONTACTS' | translate}} -
            <strong>{{ totalItems | async }} </strong>{{'CONTACTS.CONTACTS' | translate}}</span>
        </div>

        <div class="flex align-items-center justify-content-end" aria-label="contact-filters">
            <!-- Filter -->
            <div class="ml-2 flex" aria-label="filter-section">
              <div class="hidden md:inline-block" (click)="filterList.toggle($event)">
                <p-button label="More Filters" styleClass="p-button-outlined text-sm mr-2" icon="fa fa-filter" aria-label="filter-button-desktop">
                </p-button>
              </div>
              <div class="md:hidden" (click)="filterList.toggle($event)">
                <p-button styleClass="p-button-outlined text-sm h-full" icon="fa fa-filter" aria-label="filter-button-mobile">
                </p-button>
              </div>
  
              <p-overlayPanel #filterList styleClass="w-22rem md:w-25rem" aria-label="filter-panel">
                <ng-template pTemplate>
                  <i (click)="filterList.hide($event)"
                    class="fa fa-times text-xl text-600 absolute right-0 top-0 cursor-pointer mt-3 mr-3" aria-label="close-filter" data-testid="close-filter"></i>
                  <!-- Dropdown Content -->
                  <div class="mb-3" aria-label="filter-content">
                    <!-- Date -->
                    <form [formGroup]="customFilterForm" aria-label="filter-form">

                      <!-- <div class="mb-4" aria-label="tenant-filter-label">
                        <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="tenant-filter-label">
                          {{'CONTACTS.TENANT' | translate}}
                        </h4>
                      <multi-tenant-list  [contactData]="selectedContactData"
                       (emittedTenants)="selectTenants($event)" [selectionMode]="'checkbox'" [styleClass]="'w-full h-full border-none header__tenant-list'">
                      </multi-tenant-list>
                      </div> -->

                      <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="date-filter-label">
                        {{'CONTACTS.CONTACT_UPDATED_DATE' | translate}}
                       </h4>
                       <div class="mb-4 flex align-items-center" aria-label="date-range">
                         <p-calendar [showIcon]="true" formControlName="updated_from_date" placeholder="DD/MM/YY"
                           inputStyleClass="text-sm" aria-label="from-date-picker"></p-calendar>
                         <div class="mx-3" aria-label="date-separator">To</div>
                         <p-calendar [showIcon]="true" formControlName="updated_to_date" placeholder="DD/MM/YY"
                           inputStyleClass="text-sm" aria-label="to-date-picker"></p-calendar>
                       </div>
  
                      <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="source-filter-label">
                        {{'CONTACTS.MORE_FILTERS.SOURCE' | translate}}
                      </h4>
                      <p-dropdown [options]="sourceCollection" formControlName="source" optionLabel="value" filterBy="name"
                      placeholder="{{'CONTACTS.MORE_FILTERS.FILTER_BY_SOURCE' | translate}}" styleClass="w-full text-sm" aria-label="source-dropdown">
                      <ng-template pTemplate="selectedItem">
                        <div class="text-sm" *ngIf="SelectedSource.value">
                          {{SelectedSource.value.value}}
                        </div>
                      </ng-template>
                      <ng-template let-source pTemplate="item">
                        <div class="text-sm">{{source.value}}</div>
                      </ng-template>
                      </p-dropdown>

                      <h4 class="font-medium text-700 text-xs mt-2 mb-2 block uppercase" aria-label="status-filter-label">
                        {{'CONTACTS.MORE_FILTERS.STATUS' | translate}}
                      </h4>

                      <p-dropdown [options]="statusCollection" styleClass="w-full text-sm" formControlName="status" optionLabel="value" filterBy="name"
                       placeholder="{{'CONTACTS.MORE_FILTERS.FILTER_BY_STATUS' | translate}}" aria-label="status-dropdown">
                        <ng-template pTemplate="selectedItem">
                          <div class="text-sm" *ngIf="SelectedStatus.value">
                            {{SelectedStatus.value.value}}
                          </div>
                        </ng-template>
                        <ng-template let-status pTemplate="item">
                          <div class="text-sm">{{status.value}}</div>
                        </ng-template>
                        
                      </p-dropdown>

                    </form>
                  </div>
                  <!-- Dropdown Content -->
  
                  <!-- Dropdown Footer -->
                  <div
                    class="border-top-1 border-300 py-2 px-3 flex align-items-center justify-content-between -mb-3 -mx-3" aria-label="filter-footer">
                    <p-button label="Reset Filters" styleClass="p-button-link text-sm"
                      pStyleClass="@grandparent" (click)="resetFilter(); filterList.hide($event)" enterClass="hidden"
                      enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" aria-label="reset-filters">
                    </p-button>
                    <button pButton pRipple label="Apply Filter" class="text-sm"
                      pStyleClass="@grandparent" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                      leaveActiveClass="fadeout" (click)="applyFilter(customFilterForm); filterList.hide($event)" aria-label="apply-filters">
                    </button>
                  </div>
                  <!-- Dropdown Footer -->
                </ng-template>
              </p-overlayPanel>
            </div>

              <!-- <p-button [loading]="exporting|async" (click)="ExportData()" label="Export Contacts" icon="fa fa-file-excel" styleClass="hidden md:inline-block text-sm p-button-text" aria-label="export-contacts-desktop"></p-button>
              <p-button [loading]="exporting|async" (click)="ExportData()" icon="fa fa-file-excel" styleClass="md:hidden p-button-outlined ml-2" aria-label="export-contacts-mobile"></p-button> -->
        </div>
      </div>
      <!-- Table Options -->
      <div class="flex align-items-center flex-wrap text-sm mt-1 border-top-1 border-300" *ngIf="showBulkActionBar" aria-label="bulk-actions">
        <!-- Checkbox -->
        <div class="my-2 flex align-items-center mr-2 md:mr-3 white-space-nowrap" aria-label="selected-count">
          <span>{{ selectedContact.size }} Contacts selected </span>
          <i class="fa fa-arrow-right ml-3 hidden xl:inline" aria-label="arrow-icon"></i>
        </div>
        <!-- Checkbox -->

        <!-- Send Email -->
        <button pButton pRipple type="button" label="Send Email" 
          class="p-button-text text-xs md:text-sm md:mr-3 md:my-2" icon="fa fa-envelope" aria-label="send-email-button">
        </button>
        <!-- Send Email -->

        <!-- Send SMS -->
        <button pButton pRipple type="button" label="Send SMS" 
          class="p-button-text text-xs md:text-sm md:mr-3 md:my-2" icon="fa fa-comment" aria-label="send-sms-button">
        </button>
        <!-- Send SMS -->

        <!-- Convert to Prospect -->
        <button pButton pRipple type="button" label="Convert to Prospect" 
          class="p-button-text text-xs md:text-sm md:mr-3" icon="fa fa-exchange-alt" aria-label="convert-to-prospect-button">
        </button>
        <!-- Convert to Prospect -->
      </div>
      <!-- Table Options -->
    </div>

    <app-data-grid [loading]="loading" [columnData]="tableData" [totalRecords]="totalRecordLength" [columns]="columns"
      (loadNextData)="fetchNextSetData($event)" [selectable]="selectAllContactsData" (emitValue)="handleEvent($event)"
      (emitSelectValue)="handleSelectAll($event)" (onAction)="onGridAction($event)"
      [EmptyState]="emptyStateComponent$" [gridName]="'contacts-list'" [resizableColumns]="true" [columnResizeMode]="'expand'"
      aria-label="contacts-data-grid">
    </app-data-grid>
  </div>
</div>

<create-client-profile-sidebar *ngIf="showCreateProspectPopup" [formType]="'contact'" [contactData]="selectedContactData" [showProspect]="showCreateProspectPopup" [searchData]="searchData"
  (hideProspect)="hidePopup($event)" (proceedToSignup)="proceedToSignup($event)" (GoToClientDetails)="GoToClientDetails($event)" aria-label="create-prospect-sidebar">
</create-client-profile-sidebar>

<p-toast position="top-right" [breakpoints]="{'767px': {width: '100%', left: '0'}}" aria-label="toast-message"></p-toast> 